import React, {useEffect, useMemo, useState} from "react";
import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    Box,
    createStyles,
    makeStyles,
    Theme,
    Typography,
    IconButton,
} from "@material-ui/core";
import ExpandMoreIcon from "@material-ui/icons/ExpandMoreRounded";
import ReplayIcon from "@material-ui/icons/Replay";

import {useDispatch, useSelector} from "react-redux";
import {FormattedTime} from "react-intl";
import {AgendaElement, AgendaElementType, Registration, ThinkTankTable, ThinkTankRealTable} from "../../models/models";
import {AgendaThinkTankRoundDetail} from "./AgendaThinkTankRoundDetail";
import {AgendaKeynoteRoundDetail} from "./AgendaKeynoteRoundDetail";
import {
    retrieveThinkTankSeating,
    selectThinkTankSeatings,

    selectThinkTanks,
    selectThinkTankRealTables,
} from "../badge/thinkTankSeatingSlice";
import {retrieveRegistrations, selectRegistration, selectRegistrations,} from "../registrations/registrationsSlice";
import Config from "../../config";
import {selectToken} from "../authentication/authenticationSlice";
import {retrieveEvent, selectEvent} from "../badge/eventSlice";
import {retrieveDinnerSeating, selectDinnerSeatings,} from "../badge/dinnerSeatingSlice";
import {AgendaDinnerRoundDetail} from "./AgendaDinnerRoundDetail";
import {retrieveProfile, selectProfile} from "../registrations/registrationsSlice";
import {FirstLoginFlowDialog} from "../firstLoginFlow/FirstLoginFlowDialog";
import {SponsorBanner} from "../../components/sponsorBanner/SponsorBanner";
import {retrieveBranding, selectBranding} from "../badge/brandingSlice";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      flex: 1,
      display: "flex",
      flexDirection: "column",
      paddingBottom: 20,
      paddingLeft: 10,
      paddingRight: 10,
      backgroundColor: theme.palette.background.default,
      overflow: "auto",
    },
    indicator: {
      height: 10,
      width: 10,
      borderRadius: 5,
      backgroundColor: theme.palette.primary.main,
      marginLeft: 10,
      marginRight: 10,
      marginTop: 5,
    },
    name: {
      fontWeight: "bold",
    },
    icon: {
      color: theme.palette.text.primary,
    },
    row: {
      display: "flex",
      flex: 1,
      position: "relative",
    },
    line: {
      position: "absolute",
      width: 2,
      left: "calc(50% - 1px)",
      backgroundColor: theme.palette.primary.main,
      top: 6,
      bottom: -70,
      zIndex: 1000,
    },
    spacer: {
      flex: 1,
    },
    accordionCollapsed: {
      backgroundColor: "rgba(0, 0, 0, 0)",
      transition: "background-color 500ms",
      boxShadow: "none",
      "&::before": {
        display: "none",
      },
    },
    accordionExpanded: {
      borderRadius: 10,
      backgroundColor: theme.palette.background.paper,
      boxShadow: "none",
      "&::before": {
        display: "none",
      },
    },
  })
);

export const Agenda = () => {
  const classes = useStyles();

  const dispatch = useDispatch();

  const [expandedSection, setExpandedSection] = useState<number>();

  const registrations = useSelector(selectRegistrations);
  const registration = useSelector(selectRegistration(Config.getInstance().getRegistrationID()));
  const profile = useSelector(selectProfile(Config.getInstance().getRegistrationID()));
  const brandingPartners = useSelector(selectBranding);
  const event = useSelector(selectEvent);
  const authToken = useSelector(selectToken);

  useEffect(() => {
    if (authToken) {
      dispatch(retrieveEvent(authToken, Config.getInstance().getEventID()));
      dispatch(retrieveRegistrations(authToken, Config.getInstance().getEventID()));
      dispatch(retrieveProfile(authToken,Config.getInstance().getEventID(),Config.getInstance().getRegistrationID()));
      dispatch(retrieveBranding(Config.getInstance().getPublicToken(), Config.getInstance().getEventID()));
    }
  }, [authToken]); // eslint-disable-line react-hooks/exhaustive-deps

  const handleReload = () => {
    if (authToken) {
      dispatch(retrieveEvent(authToken, Config.getInstance().getEventID()));
      dispatch(retrieveRegistrations(authToken, Config.getInstance().getEventID()));
      dispatch(retrieveProfile(authToken,Config.getInstance().getEventID(),Config.getInstance().getRegistrationID()));
      dispatch(retrieveBranding(Config.getInstance().getPublicToken(), Config.getInstance().getEventID()));
    }
  };

  const agendaNetworkingA: AgendaElement[] = [
    new AgendaElement(
      "1",
      AgendaElementType.Other,
      "Interaktives Rahmenprogramm - Speed2Connect",
      <Box>
        <Typography color="textPrimary">Speed2Connect</Typography>
        <Typography color="textSecondary">• Allgemeine Anfragen & Problemstellungen</Typography>
        <Typography color="textSecondary">• Logistik</Typography>
        <Typography color="textSecondary">• Rückstandsanalytik</Typography>
        <Typography color="textSecondary">• Mikrobiologische Untersuchungen</Typography>
        <Typography color="textSecondary">• Allgemeine chemische Analysen</Typography>
        <Typography color="textSecondary">• Hygiene- und Qualitätssicherungssysteme (z.B. IFS, BRC, HACCP)</Typography>
        <Typography color="textSecondary">• Migrationsanalysen & Verpackungsprüfungen</Typography>
      </Box>,
      "2021-05-21T13:50:00+02:00",
      "2021-05-21T14:35:00+02:00"
    ),
    new AgendaElement(
      "1",
      AgendaElementType.Other,
      "Interaktives Rahmenprogramm - Kaffee Pause",
      "Kaffee Pause",
      "2021-05-21T14:35:00+02:00",
      "2021-05-21T14:55:00+02:00"
    ),
    new AgendaElement(
      "1",
      AgendaElementType.Other,
      "Interaktives Rahmenprogramm - VR Station",
      "VR - Station",
      "2021-05-21T14:55:00+02:00",
      "2021-05-21T15:40:00+02:00"
    )
  ]

  const agendaNetworkingB: AgendaElement[] = [
    new AgendaElement(
      "1",
      AgendaElementType.Other,
      "Interaktives Rahmenprogramm - VR Station",
      "VR - Station",
      "2021-05-21T13:50:00+02:00",
      "2021-05-21T14:35:00+02:00"
    ),
    new AgendaElement(
      "1",
      AgendaElementType.Other,
      "Interaktives Rahmenprogramm - Kaffee Pause",
      "Kaffee Pause",
      "2021-05-21T14:35:00+02:00",
      "2021-05-21T14:55:00+02:00"
    ),
    new AgendaElement(
      "1",
      AgendaElementType.Other,
      "Interaktives Rahmenprogramm - Speed2Connect",
      <Box>
        <Typography color="textPrimary">Speed2Connect</Typography>
        <Typography color="textSecondary">• Allgemeine Anfragen & Problemstellungen</Typography>
        <Typography color="textSecondary">• Logistik</Typography>
        <Typography color="textSecondary">• Rückstandsanalytik</Typography>
        <Typography color="textSecondary">• Mikrobiologische Untersuchungen</Typography>
        <Typography color="textSecondary">• Allgemeine chemische Analysen</Typography>
        <Typography color="textSecondary">• Hygiene- und Qualitätssicherungssysteme (z.B. IFS, BRC, HACCP)</Typography>
        <Typography color="textSecondary">• Migrationsanalysen & Verpackungsprüfungen</Typography>
      </Box>,
      "2021-05-21T14:55:00+02:00",
      "2021-05-21T15:40:00+02:00"
    )
  ]


  const agendaLaboratory: AgendaElement[] = [
      new AgendaElement("1",
                        AgendaElementType.Other,
                        "Shuttle zum Labor & Einführung im Labor",
                        "",
                        "2021-05-21T13:50:00+02:00",
                        "2021-05-21T14:10:00+02:00"),
      new AgendaElement("1",
                        AgendaElementType.Other,
                        "Laborbesichtigung & praktische Demonstrationen",
                        "",
                        "2021-05-21T14:10:00+02:00",
                        "2021-05-21T15:10:00+02:00"),
      new AgendaElement("1",
                        AgendaElementType.Other,
                        "Shuttle zurück zum Tagungsort",
                        "",
                        "2021-05-21T15:10:00+02:00",
                        "2021-05-21T15:40:00+02:00")
  ]

  const agendaEmpty: AgendaElement[] = [
      new AgendaElement("1",
                        AgendaElementType.Other,
                        "Kein Nachmittagsprogramm ausgewählt",
                        "Bitte wenden Sie sich an die Event Organisation",
                        "2021-05-21T13:50:00+02:00",
                        "2021-05-21T15:40:00+02:00")
  ]


  const dynamicAgendaElements = () => {
    console.log(registration.eventOption)
    if(registration.eventOption === 'bilacon-laboratory'){
      return agendaLaboratory;
    } else if(registration.eventOption === 'bilacon-networking' &&
              registration.eventGroup === 1){
      return agendaNetworkingA;
    } else if(registration.eventOption === 'bilacon-networking' &&
              registration.eventGroup === 2){
      return agendaNetworkingB;
    } else{
      return agendaEmpty
    }
  }

  const agendaMain: AgendaElement[] = [
    new AgendaElement(
      "1",
      AgendaElementType.Other,
      "Registrierung und Begrüßung",
      "",
      "2021-05-21T09:00:00+02:00",
      "2021-05-21T09:30:00+02:00"
    ),
    new AgendaElement(
      "1",
      AgendaElementType.Other,
      "Eröffnung durch Herrn Dr. Christian Rebhan",
      "",
      "2021-05-21T09:30:00+02:00",
      "2021-05-21T09:45:00+02:00"
    ),
    new AgendaElement(
      "1",
      AgendaElementType.Other,
      "Keynote 1 - Dr. Monika Christlbauer & Simone Schmidt",
      "\"Das Leben riecht besser mit uns - Einblicke in die faszinierende Welt der Aromastoffe\" - Dr. Monika Christlbauer & Simone Schmidt",
      "2021-05-21T09:45:00+02:00",
      "2021-05-21T10:30:00+02:00"
    ),
    new AgendaElement(
      "1",
      AgendaElementType.Other,
      "Keynote 2 - Dr. Anna Romanotto",
      "\"klein aber kritisch - Analytik von Mikroplastik um uns herum und erste Ergebnisse\" - Dr. Anna Romanotto",
      "2021-05-21T10:30:00+02:00",
      "2021-05-21T11:15:00+02:00"
    ),
    new AgendaElement(
      "1",
      AgendaElementType.Other,
      "Kaffeepause und Networking",
      "",
      "2021-05-21T11:15:00+02:00",
      "2021-05-21T11:30:00+02:00"
    ),
    new AgendaElement(
      "1",
      AgendaElementType.Other,
      "Keynote 3 - Paul Andrei",
      "\"Aktuelle Trends in der mikrobiologischen Qualitätskontrolle! Rechtliche Anforderungen, DGHM Empefehlungen & Co.\" - Paul Andrei",
      "2021-05-21T11:30:00+02:00",
      "2021-05-21T12:15:00+02:00"
    ),
    new AgendaElement(
      "1",
      AgendaElementType.Other,
      "Mittagspause",
      "",
      "2021-05-21T12:15:00+02:00",
      "2021-05-21T13:15:00+02:00"
    ),
    new AgendaElement(
      "1",
      AgendaElementType.Other,
      "Keynote 4 - Ariane Cofré",
      "\"Lebensmittelsicherheit im Fokus: Regulatorische Neuigkeiten für Kontaminanten (PFAS, BPA und MOSH/MOAH) mit Einblicken in die Analytik\" - Ariane Cofré",
      "2021-05-21T13:15:00+02:00",
      "2021-05-21T14:00:00+02:00"
    ),
    new AgendaElement(
      "1",
      AgendaElementType.Other,
      "Keynote 5 - Dr. Andreas Müller",
      "\"Food Fraud - Wie funktioniert das eigentlich im Täterbetrieb und wer sind die Täter?\" - Dr. Andreas Müller",
      "2021-05-21T14:00:00+02:00",
      "2021-05-21T14:45:00+02:00"
    ),
    new AgendaElement(
      "1",
      AgendaElementType.Other,
      "Keynote 6 - Beate Heidorn",
      "\"Audit Ahead! Zwischen Paragraphen, Praxis und Fallstricken\" - Beate Heidorn",
      "2021-05-21T14:45:00+02:00",
      "2021-05-21T15:10:00+02:00"
    )
  ];

const agendaClosing: AgendaElement[] = [
    new AgendaElement(
      "1",
      AgendaElementType.Other,
      "Let's Connect!",
      "Praxisworkshop - Flavor Sticks & Praxisworkshop - Mikroplastik",
      "2021-05-21T15:10:00+02:00",
      "2021-05-21T23:59:00+02:00"
    )
  ];

//const agenda = [...agendaMain, ...dynamicAgendaElements(), ...agendaClosing]
  const agenda = [...agendaMain, ...agendaClosing]


  return (
    <Box className={classes.container}>

    {/*
      <FirstLoginFlowDialog
           authToken={authToken || ""}
           registrations={registrations}
           profile={profile}
           event={event}
      />
      */}

     <Box
        style={{
          display: "flex",
          flexDirection: "row",
        }}
      >
        <Box style={{ flex: 1 }}>
          <Typography
            variant="h6"
            color="textPrimary"
            style={{ marginTop: 20, marginBottom: 20 }}
          >
             Agenda
          </Typography>
        </Box>

        <Box>
           <IconButton onClick={() => handleReload()}>
              <ReplayIcon/>
           </IconButton>
        </Box>
      </Box>


      {agenda.map((agendaElement: AgendaElement, index: number) => (
        <Accordion
          expanded={expandedSection === index}
          onChange={() => {
            setExpandedSection(expandedSection === index ? undefined : index);
          }}
          className={
            expandedSection === index
              ? classes.accordionExpanded
              : classes.accordionCollapsed
          }
        >
          <AccordionSummary
            style={{ display: "flex" }}
            expandIcon={<ExpandMoreIcon className={classes.icon} />}
          >
            <Box className={classes.row}>
              <Box style={{ flex: 1 }}>
                <Typography align="left" color="textPrimary">
                  <FormattedTime value={agendaElement.startTime} />
                  {" - "}
                  {index === agenda.length - 1 && "open end"}
                  {index < agenda.length - 1 && (
                    <FormattedTime value={agendaElement.endTime} />
                  )}
                </Typography>
              </Box>
              <Box className={classes.indicator} />
              <Box style={{ flex: 1 }}>
                {index < agenda.length - 1 && expandedSection !== index && (
                  <Box className={classes.line} />
                )}
                <Typography align="right" color="textPrimary">
                  {agendaElement.name}
                </Typography>
              </Box>
            </Box>
          </AccordionSummary>
          <AccordionDetails>
            {!agendaElement.detailComponent && (
              <Typography align="left" color="textSecondary">
                {agendaElement.description}
              </Typography>
            )}
            {agendaElement.detailComponent}
          </AccordionDetails>
        </Accordion>
      ))}

       <SponsorBanner
         businessPartners={brandingPartners}
       />

    </Box>
  );
};
